'use strict';

exports.__esModule = true;
exports.searchBarTabs = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _searchBarTabs = require('../actions/search-bar-tabs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
	selectedTab: 'appointments'
};
var searchBarTabs = exports.searchBarTabs = function searchBarTabs(state, action) {
	switch (action.type) {
		case _searchBarTabs.SEARCH_TAB_CHANGED:
			return (0, _assign2.default)({}, state, { selectedTab: action.selectedTab });
		case _searchBarTabs.OPEN_SCANS_SEARCH_DROPDOWN:
			return (0, _assign2.default)({}, state, {
				scansAutocompleteDropdownOpen: true,
				healthChecksAutocompleteDropdownOpen: false,
				appointmentsAutocompleteDropdownOpen: false
			});
		case _searchBarTabs.OPEN_HEALTH_CHECKS_SEARCH_DROPDOWN:
			return (0, _assign2.default)({}, state, {
				scansAutocompleteDropdownOpen: false,
				healthChecksAutocompleteDropdownOpen: true,
				appointmentsAutocompleteDropdownOpen: false
			});
		case _searchBarTabs.OPEN_APPOINTMENTS_SEARCH_DROPDOWN:
			return (0, _assign2.default)({}, state, {
				scansAutocompleteDropdownOpen: false,
				healthChecksAutocompleteDropdownOpen: false,
				appointmentsAutocompleteDropdownOpen: true
			});
		case _searchBarTabs.OPEN_SCANS_LOCATION_DROPDOWN:
			return (0, _assign2.default)({}, state, {
				scansLocationDropdownOpen: true,
				healthChecksLocationDropdownOpen: false,
				appointmentsLocationDropdownOpen: false
			});
		case _searchBarTabs.OPEN_APPOINTMENTS_LOCATION_DROPDOWN:
			return (0, _assign2.default)({}, state, {
				scansLocationDropdownOpen: false,
				healthChecksLocationDropdownOpen: false,
				appointmentsLocationDropdownOpen: true
			});
		case _searchBarTabs.OPEN_HEALTH_CHECKS_LOCATION_DROPDOWN:
			return (0, _assign2.default)({}, state, {
				scansLocationDropdownOpen: false,
				healthChecksLocationDropdownOpen: true,
				appointmentsLocationDropdownOpen: false
			});
		case _searchBarTabs.SET_LOCATION_INPUT_FIELD:
			return (0, _extends3.default)({}, state, {
				locationInputField: action.payload.locationInputField
			});
		default:
			return state || INITIAL_STATE;
	}
};


// WEBPACK FOOTER //
// ./components/home-page/lib/reducers/search-bar-tabs.js